<template>
  <div v-if="!loadData" class="flex items-center justify-center q-py-lg">
    <q-spinner-gears size="40px" color="primary"></q-spinner-gears>
  </div>
  <div
    v-else-if="loadData && !Object.values(registrationData).length"
    class="flex full-width column items-center q-py-lg"
    style="padding: 30px 0"
  >
    <q-icon name="hide_source" class="q-mb-sm" size="40px" color="primary"></q-icon>
    <span class="block" style="font-size: 16px">No data</span>
  </div>
  <div v-else class="q-pt-lg">
    <EnvRegistration
      class="q-mb-md"
      :registrationId="registrationId"
      :registrationData="registrationData"
      :existEnvironments="environments"
    />
    <AdfWidget :registrationData="registrationData" :registrationId="registrationId" mode="read">
      <span class="label-block">ADF Records:</span>
    </AdfWidget>
  </div>

  <AccessProductsTable :accessProducts="accessProducts" :loadAccessProducts="loadAccessProducts"></AccessProductsTable>
  <VirtualApisTable :virtualApis="virtualApis" :loadAccessProducts="loadAccessProducts"></VirtualApisTable>
  <span class="label-block q-mt-md" v-if="Object.values(infraService.links).length">Links:</span>
  <div class="links" v-if="Object.values(infraService.links).length">
    <Links :infraService="infraService" />
  </div>
</template>

<script>
import AccessProductsTable from '@/pages/digitalService/components/AccessProductsTable.vue';
import Links from './Links.vue';
import EnvRegistration from '@/pages/registrations/components/EnvRegistration.vue';
import { getRegistrationEnvironments } from '@/pages/allItems/api/api';
import AdfWidget from './adf/AdfWidget.vue';
import VirtualApisTable from '@/pages/digitalService/components/VirtualApisTable.vue';

export default {
  name: 'CloudenteWidget',
  components: {
    AccessProductsTable,
    Links,
    AdfWidget,
    EnvRegistration,
    VirtualApisTable,
  },
  props: {
    infraService: { type: Object },
    accessProducts: { type: Object },
    virtualApis: { type: Array },
    loadAccessProducts: { type: Boolean, default: () => false },
    registrationId: { type: String },
  },
  data() {
    return {
      environments: [],
      registrationData: {},
      loadData: false,
    };
  },
  async mounted() {
    try {
      const { data } = await getRegistrationEnvironments(
        100,
        0,
        'created_at',
        'ASC',
        true,
        this.registrationId,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
      );
      this.environments = data;
      this.registrationData.digitalServiceApm = data[0].registration.digitalService.apmId;
      this.registrationData.infrastructureServiceApm = data[0].registration.infraService.apmId;
    } catch (error) {
      this.$notify('negative', 'Error', error.message);
    } finally {
      this.loadData = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.label-block {
  font-size: 14px;
  font-weight: bold;
}
</style>
